/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICittaCollapsibleRecommendationsViewProps } from './citta-collapsible-recommendations';

export default (props: ICittaCollapsibleRecommendationsViewProps) => {
    const { cittaCollapsibleRecommendations, collapsibleRecommendationContainer } = props;
    return (
        <Module{...collapsibleRecommendationContainer}>
            {cittaCollapsibleRecommendations}
        </Module>
    );
};
